import dataLayerPush from "@ocm/services/dataLayer.js";

export const trackVirtualPageView = (): void => {
	if (window.recommendationData) {
		dataLayerPush({ event: "virtualPageView", Recommendation: window.recommendationData?.Recommendation });
	}
};
